import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const CommentBox = ({ comment, setComment, onSubmit, onFocusChange, compact }) => (
  <motion.form
    data-testid="comment-section"
    onSubmit={(e) => {
      e.preventDefault();
      onSubmit();
    }}
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: 20 }}
    transition={{ type: "spring", stiffness: 220, damping: 24 }}
    className="rounded-3xl border border-[var(--line)] bg-[rgba(28,24,19,0.9)] backdrop-blur-xl p-3 sm:p-4"
  >
    <label htmlFor="comment" className="block text-xs uppercase tracking-[0.25em] text-[var(--muted)] mb-2">
      Vertel er iets over
    </label>
    <textarea
      id="comment"
      data-testid="review-comment-textarea"
      value={comment}
      maxLength={1000}
      onChange={(e) => setComment(e.target.value)}
      onFocus={() => onFocusChange(true)}
      onBlur={() => onFocusChange(false)}
      rows={compact ? 2 : 3}
      placeholder="Het eten, de sfeer, de mensen…"
      className="w-full resize-none bg-transparent text-base text-[var(--paper)] placeholder:text-[var(--muted)]/70 outline-none font-display italic"
    />
    <div className="flex items-center justify-between mt-2">
      <span data-testid="comment-char-count" className="font-mono-clock text-xs text-[var(--muted)]">
        {comment.length}/1000
      </span>
      <motion.button
        type="submit"
        data-testid="comment-next-btn"
        onMouseDown={(e) => e.preventDefault()}
        whileHover={{ scale: 1.04 }}
        whileTap={{ scale: 0.95 }}
        className="flex items-center gap-2 rounded-full bg-[var(--amber)] text-[var(--ink)] px-5 py-2.5 text-sm font-bold disabled:opacity-60"
      >
        Volgende <ArrowRight className="h-4 w-4" />
      </motion.button>
    </div>
  </motion.form>
);
